import React, { type FC, type ReactNode } from 'react';
import Text, { type TextProps } from '../../Text/Text';
import Helptip from '../../Helptip/Helptip';

export interface FieldLabelProps {
    className?: string;
    textProps?: TextProps;
    children?: ReactNode;
    label?: string;
    helpTipTextProps?: TextProps;
    helpTipText?: string;
}

const FieldLabel: FC<FieldLabelProps> = props => {
    const { label, children, className } = props;

    function getClassName() {
        const base = 'transition flex items-center';
        return `${base} text-sm font-medium text-gray-950 dark:text-gray-50`;
    }

    function renderHelpTip() {
        const { helpTipTextProps, helpTipText } = props;

        if (!helpTipText) return null;

        return (
            <Helptip tooltipPosition="right" className="ml-1">
                <Text {...helpTipTextProps}>{helpTipText}</Text>
            </Helptip>
        );
    }

    return (
        <div className={`${getClassName()} ${className}`}>
            {children || label}
            {renderHelpTip()}
        </div>
    );
};

export default FieldLabel;
